export default function TextBasedSectionContainer({ title, children }) {
  return (
    <section className="mx-auto max-w-screen-xl py-8 px-4 sm:py-16 lg:px-14">
      <h2 className="mb-8 border-b border-gray-200 pb-8 text-4xl font-extrabold tracking-tight text-gray-900 dark:border-gray-700 dark:text-white">
        {title}
      </h2>
      {children}
    </section>
  )
}
